import { useOutletContext } from 'react-router-dom'

import { Box, Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import createComputed from 'modules/core/hooks/createComputed'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type ReportStruct from 'modules/reports/lib/ReportStruct'
import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'

const useOptions = createComputed((reportStruct, slug, dashboard) => {
  const { navigation } = useNavigation()

  const editSqlRoute = navigation.reports.dashboards.dashboardId.templatesTemplateSlugSql.fullPath({
    dashboard_id: +dashboard.id,
    template_slug: slug,
  })

  if (reportStruct.isSQL) {
    return [
      {
        to: editSqlRoute,
        title: i18n.t('custom_reports.edit'),
      },
    ]
  }

  return [
    {
      to: navigation.reports.dashboards.dashboardId.templatesTemplateSlug.fullPath({
        dashboard_id: dashboard.id,
        template_slug: slug,
      }),
      title: i18n.t('custom_reports.edit'),
    },
    {
      to: editSqlRoute,
      title: i18n.t('custom_reports.open_sql'),
    },
  ]
})
interface Props {
  slug: string
  onAddTemplate: () => void
  loading: boolean
  reportStruct: ReportStruct
}

export function OptionsButton({ slug, onAddTemplate, loading, reportStruct }: Props) {
  const [saveOptionTooltip, toggleSaveOptionTooltip] = useToggle()
  const [open, toggle] = useToggle(false)
  const { dashboard } = useOutletContext<RouteContextParams>()
  const options = useOptions(reportStruct, slug, dashboard).get()
  const { featureAvailability } = useFeatureAvailability(Features.analytics_advanced_reports)

  return (
    <Box flexDirection="row" gap="s8">
      <Tooltip
        attachment="top center"
        targetAttachment="bottom center"
        type="black"
        size="small"
        open={saveOptionTooltip}
        toggle={toggleSaveOptionTooltip}
      >
        <Button onClick={onAddTemplate} type="secondary" disabled={loading} iconName="add" />
        {i18n.t('custom_reports.add_report')}
      </Tooltip>
      {featureAvailability.available && (
        <Popover
          attachment="top right"
          targetAttachment="bottom center"
          open={open}
          toggle={toggle}
        >
          <Button onClick={toggle(true)} type="secondary" iconName="ellipsis" />
          <PopoverContent onClose={toggle(false)} options={options} />
        </Popover>
      )}
    </Box>
  )
}
